import { render, staticRenderFns } from "./EventInfoIcon.vue?vue&type=template&id=a35140bc&scoped=true&"
import script from "./EventInfoIcon.vue?vue&type=script&lang=js&"
export * from "./EventInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35140bc",
  null
  
)

export default component.exports